import { SubsectionsButtonsOptions } from './subsections-buttons-options.enum';

export const FaucetOptions = { ...SubsectionsButtonsOptions };
export type FaucetOptions = SubsectionsButtonsOptions;
